import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';

//我的招商活动详情报名商品列表
export const activityList = params => {
	return request({
		url: '/api/activity/product-list',
		data: params,
		method: AjaxMethod.post,
	});
};

//我的招商活动详情报名商品列表导出
export const exportActivityList = (params, notOrigin = true) => {
	return request({
		url: '/api/activity/product-list-export',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

//活动同步
export const activitySync = params => {
	return request({
		url: '/api/activity/activity-sync',
		data: params,
		method: AjaxMethod.post,
	});
};

//活动同步时间
export const getSyncTime = params => {
	return request({
		url: '/api/activity/get-sync-time',
		data: params,
		method: AjaxMethod.post,
	});
};

//二级团长活动列表
export const activitySearch = params => {
	return request({
		url: '/api/activity/search',
		data: params,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//可报名活动详情商品更新
export const activityProductSync = params => {
	return request({
		url: '/api/activity/activity-product-sync',
		data: params,
		method: AjaxMethod.post,
	});
};

//可报名活动详情未报名商品列表
export const unApplyProductList = params => {
	return request({
		url: '/api/activity/un-apply-product-list',
		data: params,
		method: AjaxMethod.post,
	});
};

//可报名活动详情已报名商品列表
export const applyProductList = params => {
	return request({
		url: '/api/activity/apply-product-list',
		data: params,
		method: AjaxMethod.post,
	});
};

//报名
export const applyactivity = params => {
	return request({
		url: '/api/activity/apply-activity',
		data: params,
		method: AjaxMethod.post,
	});
};

//活动详情
export const activityDetail = params => {
	return request({
		url: '/api/activity/activity-detail',
		data: params,
		method: AjaxMethod.post,
	});
};

//活动审核
export const auditActivity = params => {
	return request({
		url: '/api/activity/activity-product-audit',
		data: params,
		method: AjaxMethod.post,
	});
};

// 二级团长列表
export const getInstitutionList = params => {
	return request({
		url: '/api/second-institution/institution-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};
// 二级团长列表-样品/合作-支持二级团筛选
export const getInstitutionSelectList = params => {
	return request({
		url: '/api/second-institution/select-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 新增二级团长
export const addInstitution = data => {
	return request({
		url: '/api/second-institution/add-institution',
		data,
		method: AjaxMethod.post,
	});
};

// 编辑二级团长
export const updateInstitution = data => {
	return request({
		url: '/api/second-institution/edit-institution',
		data,
		method: AjaxMethod.post,
	});
};

// 获取团长详情
export const getInstitutionInfo = params => {
	return request({
		url: '/api/second-institution/institution-info',
		params,
		method: AjaxMethod.get,
	});
};

// 新增联系人
export const addinstitutionContact = data => {
	return request({
		url: '/api/second-institution-contact/add-contact',
		data,
		method: AjaxMethod.post,
	});
};

// 编辑联系人
export const editinstitutionContact = data => {
	return request({
		url: '/api/second-institution-contact/edit-contact',
		data,
		method: AjaxMethod.post,
	});
};

// 联系人列表
export const getInstitutionContactList = params => {
	return request({
		url: '/api/second-institution-contact/contact-list',
		params,
		method: AjaxMethod.get,
	});
};

// 达人列表
export const getInstitutionAnchorList = params => {
	return request({
		url: '/api/second-institution-anchor/anchor-list',
		params,
		method: AjaxMethod.get,
	});
};

// 达人列表v1
export const getInstitutionInstitutionList = params => {
	return request({
		url: '/api/second-institution-anchor/institution-anchor-list',
		params,
		method: AjaxMethod.get,
	});
};

// 新增关联达人
export const addinstitutionAnchor = data => {
	return request({
		url: '/api/second-institution-anchor/add-anchor',
		data,
		method: AjaxMethod.post,
	});
};

// 合作数据
export const getPartnerData = params => {
	return request({
		url: '/api/second-institution/partner-data',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 成交数据
export const getFinishData = params => {
	return request({
		url: '/api/second-institution/finish-data',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 待办数据
export const getWaitData = params => {
	return request({
		url: '/api/second-institution/wait-data',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 合作团长列表（申样搜索）
export const getInstitutionBaseList = params => {
	return request({
		url: '/api/second-institution/base-info-list',
		params,
		method: AjaxMethod.get,
	});
};

// 寄样时选择达人提示
export const directSendCheck = params => {
	return request({
		url: '/api/second-institution-anchor/check-cooperate',
		params,
		method: AjaxMethod.get,
	});
};

// 关联达人的默认地址
export const getInstitutionAnchorSite = params => {
	return request({
		url: '/api/sample-order/institution-anchor-site',
		params,
		method: AjaxMethod.get,
	});
};

// 修改报名状态
export const updApplyStatus = data => {
	return request({
		url: '/api/activity/upd-apply-status',
		data,
		method: AjaxMethod.post,
	});
};
// 新建招商活动
export const activityCreate = params => {
	return request({
		url: '/api/activity/activity-create',
		data: params,
		method: AjaxMethod.post,
	});
};

// 我的招商活动列表
export const getActivityList = params => {
	return request({
		url: '/api/activity/my-activity-search',
		params,
		method: AjaxMethod.get,
	});
};

// 活动三级类目
export const getActivityCategoryList = params => {
	return request({
		url: '/api/activity/activity-category',
		params,
		method: AjaxMethod.get,
	});
};

// 活动三级类目
export const createKsActivity = data => {
	return request({
		url: '/api/activity/create-ks',
		data,
		method: AjaxMethod.post,
	});
};

// 我的招商活动列表
export const ksProductList = params => {
	return request({
		url: '/api/activity/product-list-ks',
		data: params,
		method: AjaxMethod.post,
	});
};

// 审核活动报名商品(快手)
export const ksActivityAudit = params => {
	return request({
		url: '/api/activity/activity-product-audit-ks',
		data: params,
		method: AjaxMethod.post,
	});
};

// 批量审核活动报名商品(快手)
export const ksActivityBatchAudit = data => {
	return request({
		url: '/api/product/batch-audit-ks',
		data,
		method: AjaxMethod.post,
	});
};

// 商品管理审核商品-并且认领商品(快手)
export const ksActivityAuditClaim = params => {
	return request({
		url: '/api/activity/activity-product-audit-ks-claim',
		data: params,
		method: AjaxMethod.post,
	});
};

// 导出(快手)
export const ksActivityExport = (params, notOrigin = true) => {
	return request({
		url: '/api/activity/export',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};

// 关闭活动(快手)
export const ksActivityCloseKs = params => {
	return request({
		url: '/api/activity/close-ks',
		data: params,
		method: AjaxMethod.post,
	});
};

// 删除活动(快手)
export const ksActivityDelKs = params => {
	return request({
		url: '/api/activity/delete-ks',
		data: params,
		method: AjaxMethod.post,
	});
};

// 关闭活动(快手)
export const closeKsActivity = data => {
	return request({
		url: '/api/activity/close-ks',
		data,
		method: AjaxMethod.post,
	});
};

// 删除活动(快手)
export const deleteKsActivity = data => {
	return request({
		url: '/api/activity/delete-ks',
		data,
		method: AjaxMethod.post,
	});
};

// 团长修改地址
export const institutionDeliveryInfo = data => {
	return request({
		url: '/api/contact/upd-team-institution-delivery-info',
		data,
		method: AjaxMethod.post,
	});
};

// 抖音团长商品通过
export const dyConfirm = data => {
	return request({
		url: '/api/activity/activity-product-audit-dy-confirm',
		data,
		method: AjaxMethod.post,
	});
};
// // 抖音团长商品拒绝
export const dyRefuse = data => {
	return request({
		url: '/api/activity/activity-product-audit-dy-refuse',
		data,
		method: AjaxMethod.post,
	});
};
//视频号团长商品 通过/拒绝
export const spAuditClaim = data => {
	return request({
		url: '/product/partner/colonelProduct/sphAuditClaim',
		data,
		method: AjaxMethod.post,
	});
};
// 审核活动报名商品(抖音)
export const dyActivityAuditBatch = data => {
	return request({
		url: '/api/product/batch-audit-dy',
		data,
		method: AjaxMethod.post,
	});
};
//抖音批量 通过/拒绝
export const dyBatchAuditConfirm = data => {
	return request({
		url: '/api/product/audit-dy',
		data,
		method: AjaxMethod.post,
	});
};

//快手批量 通过/拒绝
export const ksBatchAuditConfirm = data => {
	return request({
		url: '/api/product/audit-ks',
		data,
		method: AjaxMethod.post,
	});
};
//视频号批量 通过/拒绝
export const spBatchAuditConfirm = data => {
	return request({
		url: '/api/product/audit-sph',
		data,
		method: AjaxMethod.post,
	});
};

//获取团长规则配置
export const GetRule = params => {
	return request({
		url: '/api/team-conf/get-institution',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//更新团长跟进规则
export const SetRule = data => {
	return request({
		url: '/api/team-conf/update-institution',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//获取一对多最终跟进人列表分页
export const institutionGetWaitFix = params => {
	return request({
		url: '/api/institution/flow-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//可报活动列表
export const activityKsList = params => {
	return request({
		url: '/api/activity-ks/search-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//可报活动列表
export const activityKsApplyList = params => {
	return request({
		url: '/api/activity-ks/search-apply-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//新增快手合作团长
export const institutionCreate = params => {
	return request({
		url: '/api/second-institution/add-institution-ks',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//编辑快手合作团长
export const institutionEdit = data => {
	return request({
		url: '/api/second-institution/edit-institution-ks',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//快手合作团长详情
export const institutionDetail = params => {
	return request({
		url: '/api/second-institution/institution-info-ks',
		params,
		method: AjaxMethod.get,
	});
};

//添加快手关联达人
export const institutionAddAnchorKs = params => {
	return request({
		url: '/api/second-institution-anchor/add-anchor-ks',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//快手活动详情
export const activityksDetail = params => {
	return request({
		url: '/api/activity-ks/detail',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//可报名活动商品列表
export const permitApplyProductList = params => {
	return request({
		url: '/api/activity-ks/permit-apply-product-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//已报名活动商品列表
export const ksApplyProductList = params => {
	return request({
		url: '/api/activity-ks/apply-product-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//活动报名(单个)
export const activityKsApplyOne = params => {
	return request({
		url: '/api/activity-ks/apply-one',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//取消报名
export const cancelApply = params => {
	return request({
		url: '/api/activity-ks/cancel-apply',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//取消报名
export const queryPartnerDataTotal = params => {
	return request({
		url: '/api/second-institution/institution-list-static',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//修改报名商品
export const editApplyProduct = params => {
	return request({
		url: '/api/activity-ks/edit-apply-product',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//修改报名商品
export const followUserList = params => {
	return request({
		url: '/api/second-institution/follow-user-list',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//千团优选
export const productTeamList = data => {
	return request({
		url: '/api/product-common/team-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//待审核列表
export const applyAuditList = data => {
	return request({
		url: '/api/apply-product/audit-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//推广商品列表
export const productCommonList = data => {
	return request({
		url: '/api/product-common/promotion-list',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//推广状态
export const productCommonLog = data => {
	return request({
		url: '/api/product-common/log',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//添加商品到公海
export const productCommonAdd = data => {
	return request({
		url: '/api/product-common/add',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//千团优选关闭推广
export const productCommonClose = data => {
	return request({
		url: '/api/product-common/close',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//千团优选开启推广
export const productCommonOpen = data => {
	return request({
		url: '/api/product-common/open',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//千团优选删除商品
export const productCommonDelete = data => {
	return request({
		url: '/api/product-common/delete',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//千团优选列表上面统计
export const teamListStatics = data => {
	return request({
		url: '/api/product-common/team-list-statics',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//千团优选商品机制详情
export const productCommonInfo = data => {
	return request({
		url: '/api/product-common/info',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//编辑千团优选商品机制详情
export const productCommonEdit = data => {
	return request({
		url: '/api/product-common/edit',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//审核通过
export const applyPuditPass = data => {
	return request({
		url: '/api/apply-product/audit-pass',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//审核拒绝
export const applyPuditFail = data => {
	return request({
		url: '/api/apply-product/audit-fail',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//列表统计项
export const productTeamCount = data => {
	return request({
		url: '/api/product-common/team-count',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};

//获取账号权益
export const privilege = params => {
	return request({
		url: '/api/common/privilege',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

//快手-增减招商活动达人信息
export const investmentAnchorKs = data => {
	return request({
		url: '/api/activity/investment-anchor-ks',
		data,
		method: AjaxMethod.post,
		notOrigin: true,
	});
};
